import { render } from "./PaginationBarLocal.vue?vue&type=template&id=2c51c67b"
import script from "./PaginationBarLocal.vue?vue&type=script&lang=js"
export * from "./PaginationBarLocal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__